import qs from "qs";
import { auth } from "./routes/auth";
import { SESSION_STATE_KEY } from "./store";
import axios from "axios";
import configuration from "./configurations";
import storage from './storage';

const getToken = async () => {
  try {
    const state = await storage.getItem(SESSION_STATE_KEY);

    if (!state) {
      console.log('ℹ️ No session state found in storage');
      return null;
    }

    // Handle case where state might be a string (shouldn't happen with our storage, but be safe)
    let parsedState = state;
    if (typeof state === 'string') {
      try {
        parsedState = JSON.parse(state);
      } catch (parseError) {
        console.error('❌ Failed to parse session state:', parseError);
        return null;
      }
    }

    // Extract token from state
    const token = parsedState?.auth?.user?.token || parsedState?.auth?.token || null;

    if (token) {
      console.log('✅ Token retrieved from storage');
    } else {
      console.log('⚠️ No token found in session state');
    }

    return token;
  } catch (error) {
    console.error('❌ Failed to get token from storage:', error);
    return null;
  }
};

const AnswerHandler = (json) => {
  try {
    console.log(
      json,
      json.success === false && json.error_type === "EXPIRED_TOKEN",
      json.success,
      json.error_type
    );
    if (json.success === false && json.error_type === "EXPIRED_TOKEN") {
      window.location.href = auth.LOGIN.path;
    }
    return new Promise((resolve, reject) => resolve(json));
  } catch (e) {
    throw new Error(e.getMessage());
  }
};

export const request = {
  post: async (url, params = {}, headers = {}, signal) => {
    const token = await getToken();
    return fetch(url, {
      method: "POST",
      signal,
      body: JSON.stringify(params),
      headers: {
        ...headers,
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then(AnswerHandler);
  },
  get: async (url, params = {}, headers = {}) => {
    const token = await getToken();
    return fetch(url + "?" + qs.stringify(params), {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        ...headers,
      },
    }).then((data) => data.json());
  },
  delete: async (url, params = {}, headers = {}) => {
    const token = await getToken();
    return fetch(url, {
      method: "DELETE",
      data: qs.stringify(params),
      headers: {
        Authorization: "Bearer " + token,
        ...headers,
      },
    }).then((data) => data.json());
  },
  postImage: async (url, body, headers = {}) => {
    const token = await getToken();
    return fetch(url, {
      method: "POST",
      body: body,
      headers: {
        Authorization: "Bearer " + token,
        ...headers,
      },
    }).then((data) => data.json());
  },
};
